// extracted by mini-css-extract-plugin
export default {"container":"divider_container__zrrj7"};